// extracted by mini-css-extract-plugin
module.exports = {"container":"supplier-cards_container__uPW1Y","credits":"supplier-cards_credits__fasXa"};